import { Component, Input } from '@angular/core';
import { NewsSectionCard } from 'src/app/model/card/news-section-card';

@Component({
  selector: 'app-news-section-card',
  templateUrl: './news-section-card.component.html',
  styleUrls: ['./news-section-card.component.scss']
})
export class NewsSectionCardComponent {
  @Input() newsSectionCards: NewsSectionCard[] = [];
  @Input() headImage: string = '';
  @Input() title: string = '';
  @Input() seeAllNews: string = '';
  @Input() newsUrl: string = '';

  constructor() {}
}
